import { COLUMN_SITE, COLUMN_NAME, COLUMN_TYPE, COLUMN_CONTROLLER} from "../../constants/column-types";
import { FILTER_SITES } from "../../constants/filter-types";
import { TableColumn } from "../table/TableColumn";


const ControllerPresetColumns: TableColumn[] = [
    {
        heading: "Name",
        accessor: "name",
        isNumeric: false,
        id: 0,
        active: true,
        translationKey: "name",
        columnId: COLUMN_NAME
    },
    {
        heading: "Type",
        accessor: "type",
        isNumeric: false,
        id: 1,
        active: true,
        translationKey: "type",
        columnId: COLUMN_TYPE
    },
    {
        heading: "Controllers",
        accessor: "devices",
        isNumeric: false,
        id: 2,
        active: true,
        translationKey: "controllers",
        columnId: COLUMN_CONTROLLER
    },
    {
        heading: "Site",
        accessor: "site",
        isNumeric: false,
        id: 3,
        active: true,
        searchOnName: "site.id",
        lookupName: "site.siteName",
        translationKey: "site",
        filterId: FILTER_SITES,
        columnId: COLUMN_SITE,
        settingDataName: "site"
    }
];

export default ControllerPresetColumns;
